const dev = {
    api: {
        url: "https://dev.edward.ai",
        register_user_url: 'https://dev.edward.ai/api/user',
        log_user_url: 'https://dev.edward.ai/log/in',
        dashboard_url: 'https://dev.edward.ai/dashboard',
        demo_url: 'https://dev.edward.ai/dashboard?redirect=demo',
        login_page_url: 'https://dev.edward.ai/login',
    }
};

const prod = {
    api: {
        url: 'https://' + window.location.hostname,
        register_user_url: 'https://' + window.location.hostname + '/api/user',
        log_user_url: 'https://' + window.location.hostname + '/log/in',
        dashboard_url: 'https://' + window.location.hostname + '/dashboard',
        demo_url: 'https://' + window.location.hostname + '/dashboard/?redirect=demo',
        login_page_url: 'https://' + window.location.hostname + '/login',
    }
};

const config = process.env.NODE_ENV === 'production' ? prod : dev;

export default {
    // Add common config values here
    basename: "/register/user",
    ...config
};